import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./scannedDocument_success_popup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";
import CloseButton from "../../closeButton/closeButton";
import i18n from "../../../i18n";

function ScannedDocumentPopup({ onClose }: IPopupWithoutProps) {
  return (
    <article className={popupStyles.popup} style={{ direction: i18n.dir() }}>
      <CloseButton onClick={onClose} />
      <h2 className={popupStyles.popup__title}>{t('DOCUMENT_UPLOADED_SUCCESSFULLY')}</h2>
      <p className={popupStyles.popup__text}>
        {t('UPDATE_ON_DOCUMENT_COMPLETION')}</p>
      <img
        src={doctor}
        alt="Docktor picture"
        className={popupStyles.popup__img}
      />
      <button
        type="button"
        className={popupStyles.popup__nextBtn}
        onClick={onClose}
      >
        {t('APPROVAL')}</button>
    </article>
  );
}

export default ScannedDocumentPopup;
